import { render } from "./NButtonGroup.vue?vue&type=template&id=71dd3b70&ts=true"
import script from "./NButtonGroup.vue?vue&type=script&lang=ts"
export * from "./NButtonGroup.vue?vue&type=script&lang=ts"

import "./NButtonGroup.vue?vue&type=style&index=0&id=71dd3b70&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__